module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner userFill",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "pgScroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "pgHead"
  }, [_c('span', [_vm._v("朝企家 | 帐号注册")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pgBody",
    style: ('height:' + (_vm.pageH - 60) + 'px;')
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.register(2)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("街乡负责人注册")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.register(1)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("楼宇维护人注册")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-153c924f"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/register/userRegister.vue
// module id = 1417
// module chunks = 1